import { render, staticRenderFns } from "./SelectChatOfferUserModal.vue?vue&type=template&id=a5f7abfa&scoped=true&"
import script from "./SelectChatOfferUserModal.vue?vue&type=script&lang=js&"
export * from "./SelectChatOfferUserModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectChatOfferUserModal.vue?vue&type=style&index=0&id=a5f7abfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f7abfa",
  null
  
)

export default component.exports